export default "__VITE_ASSET__8lPcP$D0__"